import type { SoundId, SoundResolver } from '@tankef/core-react';

/**
 * Maps semantic SoundIds to asset paths in /public/sounds/ (WITHOUT extension).
 * The SoundProvider's WebSoundPlayer appends .ogg or .mp3 based on browser support.
 *
 * Return null to keep an ID silent (no network request, no error).
 *
 * Sound policy (non-invasive):
 *   - financial.deposit   → ding on incoming money (most important)
 *   - status.success      → same tone, softer — KYC approval, product activation
 *   - everything else     → silent (toasts cover the feedback)
 */
const SOUND_MAP: Partial<Record<SoundId, string>> = {
  'financial.deposit': '/sounds/notification-deposit',
  'status.success': '/sounds/notification-deposit',
};

export const appSoundResolver: SoundResolver = id => SOUND_MAP[id] ?? null;
